module.exports = __webpack_public_path__ + "img/tervezhetoseg_bg_1360.7b2c3787.png";